const environment = JSON.parse(process.env.VUE_APP_RAS_ENV_MAPPING)[window.location.host] || 'develop';
const host = `${process.env.VUE_APP_CIS_HOST}/${environment}/api/v2/ci`;

export const fetchCIById = ({ id }, request) =>
  request(`${host}/${id}`, {
    method: 'GET',
    headers: new Map([['Content-Type', 'application/json']]),
  });

export const fetchCIs = ({ limit, offset }, request) =>
  request(`${host}?limit=${limit}&offset=${offset}`, {
    method: 'GET',
    headers: new Map([['Content-Type', 'application/json']]),
  });

export const saveCI = ({ name, namespace, description }, { request }) =>
  request(`${host}/name`, {
    method: 'POST',
    headers: new Map([['Content-Type', 'application/json']]),
    body: { name, namespace, description },
  });

export const saveCIDraft = ({ name, namespace, description, models }, { request }) =>
  request(`${host}/${namespace}:${name}/drafts`, {
    method: 'POST',
    headers: new Map([['Content-Type', 'application/json']]),
    body: { name, namespace, description, models },
  });

export const updateCIDraft = ({ name, namespace, description, operations }, { request }) =>
  request(`${host}/${namespace}:${name}/drafts`, {
    method: 'PATCH',
    headers: new Map([['Content-Type', 'application/json']]),
    body: { description, operations },
  });
